import { render, staticRenderFns } from "./WxLogin.vue?vue&type=template&id=269f7299&scoped=true"
import script from "./WxLogin.vue?vue&type=script&lang=js"
export * from "./WxLogin.vue?vue&type=script&lang=js"
import style0 from "./WxLogin.vue?vue&type=style&index=0&id=269f7299&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269f7299",
  null
  
)

export default component.exports